/**
 * Utility to determine if a grocery item toggle should trigger a pantry addition.
 *
 * Returns the item name (trimmed) if the item is currently unchecked
 * (about to be checked ON as purchased), or null if no pantry sync needed.
 */
export function shouldSyncToPantryOnToggle(
  item: { name: string; isChecked: boolean }
): string | null {
  if (item.isChecked) return null; // Being unchecked — no pantry action
  const trimmed = item.name.trim();
  if (trimmed.length === 0) return null;
  return trimmed;
}
